import script from "./HelmOpAppCoResourcesSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelmOpAppCoResourcesSection.vue?vue&type=script&setup=true&lang=ts"

import "./HelmOpAppCoResourcesSection.vue?vue&type=style&index=0&id=d7680648&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7680648"]])

export default __exports__